import React, { useState, useContext, useEffect } from "react";
import { Page } from "@shopify/polaris";
import { useTranslation } from "react-i18next";
import { TitleBar } from "@shopify/app-bridge-react";
import TagsForm from "./Form";
import { useParams } from "react-router-dom";
import { AppContext } from "../../../../components/global/appContext";
import { Navigate } from "react-router-dom";
import {
  useGetTag,
  useUpdateTag,
  useDeleteTag,
} from "../../../../hooks/queries/tags";
import TagsFormSkeleton from "./SkeletonForm";

export default function TagsEdit(props) {
  const { t } = useTranslation();
  const appContext = useContext(AppContext);
  let { id } = useParams();

  const [tag, setTag] = useState(null);
  const [errors, setErrors] = useState({});
  const [tagDeleted, setTagDeleted] = useState(false);

  const { data, isError } = useGetTag(id);
  useEffect(() => {
    if (data) setTag(data);
  }, [data]);
  const hasUnsavedChanges = JSON.stringify(data) !== JSON.stringify(tag);

  const updateTagMutation = useUpdateTag(id, {
    onSuccess: (data) => {
      setErrors({});
      setTag(data);
      appContext.setMessage(t("settings.tags.messages.savedSuccessfully"));
    },
    onError: (error) => {
      const errorData = error?.response?.data || {};
      if (errorData.message && !errorData.base) {
        errorData.base = [errorData.message];
      }
      if (errorData.base && !Array.isArray(errorData.base)) {
        errorData.base = [errorData.base];
      }
      setErrors(errorData);
    },
  });

  const deleteTagMutation = useDeleteTag(id, {
    onSuccess: () => {
      setTagDeleted(true);
      appContext.setMessage(t("settings.tags.messages.tagDeleted"));
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message || t("settings.tags.messages.couldntDelete");
      setErrors({ base: [message] });
    },
  });

  // Handle form submission (triggered by Save Bar)
  const handleSubmit = (e) => {
    e.preventDefault();
    updateTagMutation.mutate(tag);
  };

  // Handle form reset (triggered by Discard button in Save Bar)
  const handleReset = (e) => {
    e.preventDefault();
    setTag(data);
  };

  if (tagDeleted) return <Navigate to="/settings/tags" />;
  if (isError) return <p>{t("settings.tags.error")}</p>;
  if (tag)
    return (
      <form 
        data-save-bar 
        onSubmit={handleSubmit}
        onReset={handleReset}
      >
      <Page>
        <TitleBar
          title={tag ? tag.title : "Tag"}
          breadcrumbs={[{ content: t("settings.tags.title"), url: "/settings/tags" }]}
        />
        <TagsForm
          tag={tag}
          setTag={setTag}
          errors={errors}
          secondaryActions={[
            {
              content: t("settings.tags.actions.deleteTag"),
              destructive: true,
              outline: true,
              loading: deleteTagMutation.isLoading,
              onAction: deleteTagMutation.mutate,
            },
          ]}
        />
      </Page>
      </form>
    );
  return (
    <Page>
      <TitleBar
        title={" "}
        breadcrumbs={[{ content: t("settings.tags.title"), url: "/settings/tags" }]}
      />
      <TagsFormSkeleton
        secondaryActions={[
          {
            content: t("settings.tags.actions.deleteTag"),
            destructive: true,
            outline: true,
            loading: true,
          },
        ]}
      />
    </Page>
  );
}
